import { dateFormatString } from 'common-app/options';
import { dateFormat, formatToIsoStringCalendar } from '@isyc-react/form/modules/date';
import { parametersToRecordByCode, bailleursPhoneToPhoneItem, bailleursPhoneItemToPhone } from 'common-app/types';
export const familySituationCodeSingle = 'C';
export const signatoryApiToForm = signatory => {
    var _a, _b, _c, _d;
    return signatory
        ? {
            id: signatory.id,
            erasable: Boolean(signatory.erasable),
            sex: signatory.sex ? { value: signatory.sex.toString() } : null,
            birthName: (_a = signatory.birthName) !== null && _a !== void 0 ? _a : '',
            firstname: (_b = signatory.firstname) !== null && _b !== void 0 ? _b : '',
            surname: (_c = signatory.surname) !== null && _c !== void 0 ? _c : '',
            birthDate: signatory.birthDate ? dateFormat(signatory.birthDate, dateFormatString) : '',
            mail: (_d = signatory.mail) !== null && _d !== void 0 ? _d : '',
            personalPhone: signatory.personalPhone ? bailleursPhoneToPhoneItem(signatory.personalPhone) : null,
            mobilePhone: signatory.mobilePhone ? bailleursPhoneToPhoneItem(signatory.mobilePhone) : null,
            parameters: parametersToRecordByCode(signatory.parameters),
        }
        : {
            id: null,
            erasable: true,
            sex: null,
            birthName: '',
            firstname: '',
            surname: '',
            birthDate: '',
            mail: '',
            personalPhone: null,
            mobilePhone: null,
            parameters: {},
        };
};
export const signatoryFormToApi = signatory => {
    var _a, _b, _c;
    if (((_a = signatory.parameters['code_situation_familiale']) === null || _a === void 0 ? void 0 : _a.value) === familySituationCodeSingle) {
        signatory.parameters['date_situation_familiale'].value = '';
    }
    return {
        id: signatory.id,
        sex: (_b = signatory.sex) === null || _b === void 0 ? void 0 : _b.value,
        birthName: signatory.birthName,
        firstname: signatory.firstname,
        surname: signatory.surname,
        birthDate: signatory.birthDate
            ? (_c = formatToIsoStringCalendar(signatory.birthDate, dateFormatString)) !== null && _c !== void 0 ? _c : undefined
            : undefined,
        mail: signatory.mail,
        personalPhone: signatory.personalPhone ? bailleursPhoneItemToPhone(signatory.personalPhone) : null,
        mobilePhone: signatory.mobilePhone ? bailleursPhoneItemToPhone(signatory.mobilePhone) : null,
        parameters: Object.values(signatory.parameters).map(p => ({ id: p.id, code: p.code, value: p.value })),
    };
};
